import sortBy from 'lodash/sortBy';
import { i18n_t as $t } from '@utils/i18n';

export function sortByName (sortArray) {
    return sortBy(sortArray, (item) => item.name.toUpperCase());
}

export function createUnassignedMetaGroup (items = []) {
    return {
        name: $t('metaGroups.Custom'),
        id: '_PENDO_UNASSIGNED_META_GROUP_',
        description: 'Unassigned categories',
        length: items.length,
        type: 'metaGroup',
        items: sortByName(items),
    };
}
